<div #videoHotspotsContainer id="videoHotspotsContainer">
  <svg viewBox="0 0 1280 720" #videoHotspots id="videoHotspots">
    @if (debug) {
      <text x="15" y="15">slideId: {{ slideId }}</text>
    }
    @for (hotspot of visibleHotspots; track hotspot) {
      <g [attr.transform]="'translate(' + hotspot.x + ', ' + hotspot.y + ')'">
        <rect
          class="video-hotspot"
          fill="transparent"
          [attr.width]="hotspot.width"
          [attr.height]="hotspot.height"
          (click)="hotspotClicked.next(hotspot)"
        ></rect>
        @if (debug) {
          <text y="30">
            <tspan x="10" dy="0">w / h: {{ hotspot.width }} / {{ hotspot.height }}</tspan>
            <tspan x="10" dy="30">x / y: {{ hotspot.x }} / {{ hotspot.y }}</tspan>
            <tspan x="10" dy="30">target: {{ hotspot.targetSlideId }} / {{ hotspot.targetModuleId }}</tspan>
            <tspan x="10" dy="30">frame start / end: {{ hotspot.frameStart }} / {{ hotspot.frameEnd }}</tspan>
          </text>
        }
      </g>
    }
  </svg>
</div>
